import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import style from "./style.module.scss";

const ENTER_KEY = 13;

/**
 * OptionWrapper:
 *  - Wrapper for QuestionOptions
 */
export function OptionWrapper(props) {
  const intl = useIntl();
  const onClick = (event) => {
    event.preventDefault();
    props.selectOption();
  };

  const onKeyDown = (event) => {
    event.keyCode === ENTER_KEY && props.selectOption();
  };

  const className = `${style.wrapper} ${props.className}`;

  // Generate feedback ID for ARIA association
  const feedbackId = props.feedbackId || `option-feedback-${props.optionId}`;
  const shouldShowFeedback =
    className.includes("correct") || className.includes("incorrect");
  const isDisabled =
    className.includes("disabled") ||
    className.includes("correct") ||
    className.includes("incorrect");

  return (
    <div
      className={className}
      role={
        !className.includes("correct") && !className.includes("incorrect")
          ? "checkbox"
          : null
      }
      aria-checked={className.includes("selected") ? true : false}
      aria-disabled={isDisabled ? true : undefined}
      aria-describedby={shouldShowFeedback ? feedbackId : undefined}
      aria-label={props.ariaLabel}
      tabIndex={
        !className.includes("correct") && !className.includes("incorrect")
          ? props.tabIndex
          : null
      }
      onClick={onClick}
      onKeyDown={onKeyDown}
      dir={intl.locale == "ar" ? "rtl" : "ltr"}
    >
      {props.children}
    </div>
  );
}

OptionWrapper.propTypes = {
  /**
   * ClassName to set on Componnet
   */
  className: PropTypes.string,
  /**
   * This prop can be used to display some element
   */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
  /**
   * Fuction to Invoke when Option is selected
   */
  selectOption: PropTypes.func,
  /**
   * TabIndex to set on Component
   */
  tabIndex: PropTypes.number,
  /**
   * Unique ID of the option for ARIA association
   */
  optionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Custom feedback element ID (optional, auto-generated if not provided)
   */
  feedbackId: PropTypes.string,
  /**
   * Accessible label for screen readers (e.g., image alt-text)
   */
  ariaLabel: PropTypes.string,
};

OptionWrapper.defaultProps = {
  className: "",
  tabIndex: 0,
};
